// src/utils/printDataSecurity.js
export async function printDataSecurityList(dataList, searchTerm = "") {
  const printWindow = window.open("", "_blank");
  const title = searchTerm
    ? `Hasil Pencarian "${searchTerm}"`
    : "Laporan Data Anggota Security";

  const FIELDS = [
    { key: "nik", label: "NIK" },
    { key: "nama", label: "Nama Lengkap" },
    { key: "tempatLahir", label: "Tempat Lahir" },
    { key: "tanggalLahir", label: "Tanggal Lahir" },
    { key: "pendidikanTerakhir", label: "Pendidikan Terakhir" },
    { key: "agama", label: "Agama" },
    { key: "jenisKelamin", label: "Jenis Kelamin" },
    { key: "alamat", label: "Alamat Lengkap" },
    { key: "tinggi", label: "Tinggi (cm)" },
    { key: "berat", label: "Berat (kg)" },
    { key: "golonganDarah", label: "Golongan Darah" },
    { key: "noHp", label: "No. HP" },
    { key: "noKantor", label: "No. Kantor" },
    { key: "email", label: "Email Pribadi" },
    { key: "emailPerusahaan", label: "Email Perusahaan" },
    { key: "alamatKantor", label: "Alamat Kantor" },
    { key: "npwp", label: "NPWP" },
    { key: "noRegister", label: "No. Register" },
    { key: "bpjsKetenagakerjaan", label: "BPJS Ketenagakerjaan" },
    { key: "noBpjs", label: "BPJS Kesehatan" },
    { key: "noDplk", label: "Nomor DPLK" },
    { key: "rumusSidikJari", label: "Rumus Sidik Jari" },
    { key: "namaPerusahaan", label: "Lokasi Kerja" },
    { key: "jabatan", label: "Jabatan" },
    { key: "pangkat", label: "Pangkat" },
    { key: "diksar", label: "Diksar" },
    { key: "tmt", label: "TMT (Mulai Tugas)" },
  ];

  // Header tabel
  const tableHeader = `
    <tr>
      <th style="width:40px;">No</th>
      ${FIELDS.map((f) => `<th>${f.label}</th>`).join("")}
    </tr>
  `;

  // Isi tabel
  const tableRows = dataList
    .map(
      (data, i) => `
      <tr>
        <td style="text-align:center;">${i + 1}</td>
        ${FIELDS.map(
          (f) => `<td>${data[f.key] ? data[f.key] : "-"}</td>`
        ).join("")}
      </tr>`
    )
    .join("");

  const content = `
    <html>
      <head>
        <title>${title}</title>
        <style>
          @page {
            size: A4 landscape;
            margin: 12mm 15mm;
          }

          body {
            font-family: 'Segoe UI', Tahoma, sans-serif;
            color: #111;
            background: #fff;
          }

          body::before {
            content: "Soney Raya";
            position: fixed;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-30deg);
            font-size: 90px;
            color: rgba(0, 0, 0, 0.04);
            z-index: -1;
            pointer-events: none;
          }

          header {
            display: flex;
            align-items: center;
            border-bottom: 3px double #0f766e;
            padding-bottom: 10px;
            margin-bottom: 15px;
          }

          header img {
            width: 80px;
            height: 80px;
            object-fit: contain;
            margin-right: 18px;
          }

          header .text {
            text-align: left;
          }

          header h1 {
            margin: 0;
            font-size: 22px;
            color: #0f766e;
            text-transform: uppercase;
            font-weight: 800;
          }

          header p {
            margin: 2px 0;
            font-size: 13px;
            color: #444;
          }

          h2, h3 {
            text-align: center;
            color: #0d9488;
            margin: 4px 0;
          }

          h2 {
            font-size: 17px;
            text-transform: uppercase;
          }

          h3 {
            font-size: 14px;
            color: #444;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
            table-layout: fixed;
          }

          th, td {
            border: 1px solid #cbd5e1;
            padding: 6px 8px;
            font-size: 11px;
            vertical-align: middle;
            word-wrap: break-word;
          }

          th {
            background: linear-gradient(to bottom, #0f766e, #115e59);
            color: white;
            text-align: center;
            font-weight: 600;
          }

          tr:nth-child(even) {
            background-color: #f8fafc;
          }

          tr:hover {
            background-color: #f1f5f9;
          }

          footer {
            margin-top: 25px;
            text-align: right;
            font-size: 12px;
            color: #555;
          }

          .signature {
            margin-top: 50px;
            text-align: right;
            font-size: 13px;
            line-height: 1.4;
          }

          .signature .name {
            margin-top: 60px;
            font-weight: bold;
            text-decoration: underline;
          }

          .signature .position {
            margin-top: -4px;
          }
        </style>
      </head>

      <body>
        <header>
          <img src="${window.location.origin}/images/foto.png" alt="Logo Perusahaan" />
          <div class="text">
            <h1>Soney Raya</h1>
            <p>Ruko Jln. Koti Weref No 78A, Jayapura</p>
            <p>Email: soneyraya@gmail.com</p>
          </div>
        </header>

        <h2>${title}</h2>
        <h3>Total Data: ${dataList.length}</h3>

        <table>
          <thead>${tableHeader}</thead>
          <tbody>
            ${tableRows || "<tr><td colspan='99' style='text-align:center;'>Tidak ada data</td></tr>"}
          </tbody>
        </table>

        <div class="signature">
          <p>Jayapura, ${new Date().toLocaleDateString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })}</p>
          <p class="name">_________________________</p>
          <p class="position">Pimpinan / Kepala Unit</p>
        </div>

        <footer>
          Dicetak pada ${new Date().toLocaleString("id-ID")}
        </footer>
      </body>
    </html>
  `;

  // Cetak dokumen
  printWindow.document.write(content);
  printWindow.document.close();

  printWindow.onload = () => {
    const logo = printWindow.document.querySelector("img");
    if (logo) {
      logo.onload = () => {
        printWindow.focus();
        printWindow.print();
      };
      logo.onerror = () => {
        printWindow.focus();
        printWindow.print();
      };
    } else {
      printWindow.focus();
      printWindow.print();
    }
  };
}
